var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('v-slide-x-transition',{attrs:{"leave-absolute":"","hide-on-leave":""}},[_c('div',{staticClass:"transition mx-auto",staticStyle:{"height":"100%","max-width":"500px"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }